import { useTranslation } from 'react-i18next';

export const GlobalValue = () => {
  const { t } = useTranslation();

  return <span className="text-gray-400">{t('settings:documentUnderstandingAgent.byConnections.global')}</span>;
};
